import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    paymentList: () => {
        return HTTP.get('/payment_index', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    changeStatusPayment: (id) => {
        return HTTP.post(`/payment_switch/${id}`,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addPayment: (data) => {
        return HTTP.post('/payment_qrcode_create',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    paymentDetail: (id) => {
        return HTTP.get('/payment_qrcode_current/'+id, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editPayment: (id,data) => {
        return HTTP.post(`/payment_qrcode_update/${id}`,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    deletePayment: (id) => {
        return HTTP.post(`/payment_qrcode_destroy/${id}`,null, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}